module.exports = __webpack_public_path__ + "static/media/currentBrl.d8e0be2c.png";